import { useEffect, useState } from 'react';
import { apiClient } from '../../auth-lib';
import OrgAdminLayout from '../components/OrgAdminLayout';
import { Tabs } from '../../design-system';
import MultiSelect from '../components/reports/MultiSelect';
import ComplianceReports from '../components/reports/ComplianceReports';
import WorkloadReports from '../components/reports/WorkloadReports';
import BillingReports from '../components/reports/BillingReports';
import ClientReports from '../components/reports/ClientReports';
import PerformanceReports from '../components/reports/PerformanceReports';
import FilingTrackerReports from '../components/reports/FilingTrackerReports';
import WorkDoneReports from '../components/reports/WorkDoneReports';
import '../styles/Reports.css';

const TABS = [
  { key: 'work-done', label: 'Work Done' },
  { key: 'compliance', label: 'Compliance' },
  { key: 'filing-tracker', label: 'Filing Tracker' },
  { key: 'workload', label: 'Workload' },
  { key: 'billing', label: 'Billing' },
  { key: 'clients', label: 'Clients' },
  { key: 'performance', label: 'Performance' },
];

// Default window: trailing 12 months (matches the backend default).
const iso = (d) => d.toISOString().slice(0, 10);
const defaultFrom = () => {
  const d = new Date();
  d.setMonth(d.getMonth() - 11);
  d.setDate(1);
  return iso(d);
};

function OrgAdminReports() {
  // Work Done is the default: it's the one view that spans every service head
  // AND the extra tasks, so it answers "what have we actually done" first.
  const [tab, setTab] = useState('work-done');
  const [from, setFrom] = useState(defaultFrom());
  const [to, setTo] = useState(iso(new Date()));
  const range = { from, to };

  // Compliance-head filter: options come from the compliance-type catalog.
  const [typeOptions, setTypeOptions] = useState([]);
  const [selectedTypes, setSelectedTypes] = useState([]);

  useEffect(() => {
    apiClient
      .get('/api/compliance-types')
      .then((r) => setTypeOptions((r.data || []).map((t) => ({ value: t._id, label: t.name }))))
      .catch(() => setTypeOptions([]));
  }, []);

  return (
    <OrgAdminLayout title="Reports" subtitle="Practice-wide analytics for partners and managers">
      <div className="rep-toolbar">
        <Tabs tabs={TABS} active={tab} onChange={setTab} />
        <span style={{ flex: 1 }} />
        {/* The Filing Tracker carries its own return-type + financial-year
            pickers, so the shared date range doesn't apply to it. */}
        {tab !== 'filing-tracker' && (
          <>
            <label className="rep-date">
              From <input type="date" value={from} max={to} onChange={(e) => setFrom(e.target.value)} />
            </label>
            <label className="rep-date">
              To <input type="date" value={to} min={from} onChange={(e) => setTo(e.target.value)} />
            </label>
          </>
        )}
      </div>

      {tab === 'compliance' && (
        <div className="rep-toolbar rep-toolbar-sub">
          <span style={{ flex: 1 }} />
          <MultiSelect
            label="Types"
            options={typeOptions}
            selected={selectedTypes}
            onChange={setSelectedTypes}
            allLabel="All types"
          />
        </div>
      )}

      {tab === 'work-done' && <WorkDoneReports range={range} />}
      {tab === 'compliance' && <ComplianceReports range={range} types={selectedTypes} />}
      {tab === 'filing-tracker' && <FilingTrackerReports />}
      {tab === 'workload' && <WorkloadReports range={range} />}
      {tab === 'billing' && <BillingReports range={range} />}
      {tab === 'clients' && <ClientReports range={range} />}
      {tab === 'performance' && <PerformanceReports range={range} />}
    </OrgAdminLayout>
  );
}

export default OrgAdminReports;
